export default (function (width) {
  return "\n  width: ".concat(width, "px;\n  height: 3px;\n");
});